export default __webpack_public_path__ + "static/media/honrom.da930fe5.jpg";